export default __webpack_public_path__ + "static/media/Group-square.fb011693.svg";